import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: 'Sarah Johnson',
      role: 'CEO, TechStart Inc',
      company: 'E-Commerce Platform',
      image: 'https://public.readdy.ai/ai/img_res/a4a0cbb2cfbb90ecbf5f726f648d5ece.jpg',
      content: 'DynastyForge transformed our online presence completely. Their team delivered a stunning Shopify store that increased our conversions by 300%. The attention to detail and technical expertise is unmatched.',
      rating: 5
    },
    {
      name: 'Michael Chen',
      role: 'Founder, FitLife App',
      company: 'Mobile App Development',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20businessman%20founder%20in%20casual%20business%20attire%2C%20friendly%20smile%2C%20modern%20tech%20startup%20office%2C%20corporate%20headshot%2C%20bright%20natural%20lighting%2C%20white%20background%2C%20entrepreneur%20portrait&width=400&height=400&seq=testimonial-michael-002&orientation=squarish',
      content: 'Working with DynastyForge was an absolute pleasure. They built our fitness app from scratch and it now has over 50,000 active users. Their mobile development skills are world-class.',
      rating: 5
    },
    {
      name: 'Emily Rodriguez',
      role: 'Marketing Director, BrandCo',
      company: 'Brand & Animation',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20woman%20marketing%20director%2C%20creative%20professional%2C%20modern%20office%20setting%2C%20warm%20smile%2C%20business%20casual%20attire%2C%20bright%20natural%20lighting%2C%20white%20background%2C%20professional%20headshot&width=400&height=400&seq=testimonial-emily-003&orientation=squarish',
      content: 'The 3D animations and brand identity work exceeded all expectations. DynastyForge brought our vision to life with stunning 4K videos that generated millions of views. Highly recommended!',
      rating: 5
    },
    {
      name: 'David Thompson',
      role: 'CTO, DataFlow Systems',
      company: 'Enterprise Solutions',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20CTO%20technology%20executive%2C%20glasses%2C%20confident%20expression%2C%20modern%20tech%20office%2C%20business%20attire%2C%20bright%20natural%20lighting%2C%20white%20background%2C%20corporate%20technology%20leader%20portrait&width=400&height=400&seq=testimonial-david-004&orientation=squarish',
      content: 'DynastyForge handled our complex server infrastructure and custom development needs flawlessly. Their technical depth and problem-solving abilities are exceptional. A true partner in innovation.',
      rating: 5
    },
    {
      name: 'Lisa Anderson',
      role: 'Owner, Gourmet Bistro',
      company: 'Restaurant Website',
      image: 'https://readdy.ai/api/search-image?query=Professional%20woman%20restaurant%20owner%2C%20warm%20welcoming%20smile%2C%20elegant%20business%20attire%2C%20modern%20restaurant%20background%2C%20bright%20natural%20lighting%2C%20white%20background%2C%20hospitality%20professional%20portrait&width=400&height=400&seq=testimonial-lisa-005&orientation=squarish',
      content: 'Our new website and online ordering system have been game-changers. DynastyForge created a beautiful, user-friendly platform that our customers love. Sales have increased by 250%!',
      rating: 5
    },
    {
      name: 'James Wilson',
      role: 'VP Marketing, GlobalTech',
      company: 'Corporate Website',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20VP%20executive%20in%20suit%2C%20confident%20business%20leader%2C%20modern%20corporate%20office%2C%20professional%20headshot%2C%20bright%20natural%20lighting%2C%20white%20background%2C%20senior%20executive%20portrait&width=400&height=400&seq=testimonial-james-006&orientation=squarish',
      content: 'The team at DynastyForge delivered a world-class corporate website with multilingual support. Their professionalism, creativity, and technical skills are outstanding. Best agency we have worked with.',
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-purple-600 font-semibold text-sm uppercase tracking-wider">Testimonials</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our satisfied clients have to say about working with DynastyForge.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-3xl p-12 lg:p-16">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-shrink-0">
                <img 
                  src={testimonials[activeIndex].image}
                  alt={testimonials[activeIndex].name}
                  className="w-32 h-32 rounded-full object-cover border-4 border-white shadow-lg"
                />
              </div>
              
              <div className="flex-1 text-center lg:text-left">
                <div className="flex justify-center lg:justify-start mb-4">
                  {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-2xl"></i>
                  ))}
                </div>
                
                <p className="text-xl text-gray-700 mb-6 leading-relaxed italic">
                  "{testimonials[activeIndex].content}"
                </p>
                
                <div>
                  <div className="font-bold text-gray-900 text-lg">
                    {testimonials[activeIndex].name}
                  </div>
                  <div className="text-purple-600 font-medium">
                    {testimonials[activeIndex].role}
                  </div>
                  <div className="text-gray-500 text-sm">
                    {testimonials[activeIndex].company}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button 
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-16 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-purple-600 hover:text-white transition-all cursor-pointer group"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>

          <button 
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-16 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-purple-600 hover:text-white transition-all cursor-pointer group"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>

          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === activeIndex 
                    ? 'bg-purple-600 w-8' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
